import { render, staticRenderFns } from "./anomaly.vue?vue&type=template&id=45bd7700&scoped=true&"
import script from "./anomaly.vue?vue&type=script&lang=js&"
export * from "./anomaly.vue?vue&type=script&lang=js&"
import style0 from "./anomaly.vue?vue&type=style&index=0&id=45bd7700&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bd7700",
  null
  
)

export default component.exports